import type { BillBreakdown } from '@/calc/tariff';
import { formatLkr } from '@/lib/format';

export function EffectiveUnitPrice({
  normalBill,
  atombergBill,
}: {
  normalBill: BillBreakdown;
  atombergBill: BillBreakdown;
}) {
  const priceNormal = normalBill.units > 0 ? normalBill.totalLkr / normalBill.units : 0;
  const priceAtomberg = atombergBill.units > 0 ? atombergBill.totalLkr / atombergBill.units : 0;
  const categoryChanged = normalBill.category.id !== atombergBill.category.id;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div className="rounded-lg border border-slate-200 p-4 bg-white">
        <div className="text-xs uppercase tracking-wide text-slate-500">Effective price now</div>
        <div className="text-lg font-semibold text-slate-900 mt-1">
          {formatLkr(priceNormal)}<span className="text-sm text-slate-500"> / kWh</span>
        </div>
        <div className="text-xs text-slate-500 mt-1">Category: {normalBill.category.label}</div>
      </div>
      <div className="rounded-lg border-2 border-brand-500 p-4 bg-brand-50">
        <div className="text-xs uppercase tracking-wide text-slate-700">Effective price after</div>
        <div className="text-lg font-semibold text-slate-900 mt-1">
          {formatLkr(priceAtomberg)}<span className="text-sm text-slate-600"> / kWh</span>
        </div>
        <div className="text-xs text-slate-700 mt-1">
          Category: {atombergBill.category.label}
          {categoryChanged && <span className="ml-2 font-medium">(dropped ↓)</span>}
        </div>
      </div>
    </div>
  );
}
